var _path, _path2, _rect, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromotionsSalesMethods(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.15 41.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-promotions-sales-methods") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2,37.71c0,2.3,2.36,4.19,5.24,4.19h0a5,5,0,0,0,5.23-5.22V29.33c0-1.28-2.35,0-5.23,0h0c-2.88,0-5.24,1.88-5.24,4.19Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.16,37.71c0,2.3,2.36,4.19,5.24,4.19h0c2.88,0,5.24-1.89,5.24-4.19V33.52c0-2.3-2.36-4.19-5.24-4.19h0c-2.88,0-5.24-.21-5.24,2.1Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.58,
    y: 12.57,
    width: 12.57,
    height: 12.57,
    rx: 2.09,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.19,10.48c-.42-.35-.69,7.66,5.64,12.2s6.44-9.33,2.34-6.63S.61,10.83.19,10.48Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.57,3.23c.86-2.07-11.7-1.85-11.49,8.52s8.71,6.55,7.37,1S49.71,5.31,50.57,3.23Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88,18.85c0,10.42,10.31,18.86,23,18.86s23-8.44,23-18.86S41.65,0,28.92,0,5.88,8.44,5.88,18.85ZM18.45,6.28s5.2-2.09,9.39-2.09S37.3,6.28,37.3,6.28v4.19S32,8.38,27.84,8.38s-9.39,2.09-9.39,2.09Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionsSalesMethods);
export default __webpack_public_path__ + "static/media/promotions-sales-methods.7a1ca448a784d0fe32b3ecb70b1b50b9.svg";
export { ForwardRef as ReactComponent };